<!-- <app-academic-headers></app-academic-headers> -->
 <app-student-verification-header></app-student-verification-header>
<router-outlet></router-outlet>
<app-academic-footers></app-academic-footers>

